import React from "react";
import "./style.css";

export const Flexcontainer = () => {
  return (
    <div className="flexcontainer">
      <p className="text">
        <span className="text-wrapper">
          Last Updated: 22 October 2024
          <br />
        </span>
      </p>

      <p className="text">
        <span className="text-wrapper">
          Your satisfaction is our top priority. Please take a moment to review
          our Money-back Policy. This Money-back policy applies to products
          purchased directly through our website https://caloapp.ai. If you
          purchased the application through a third-party platform (such as the
          App Store or Google Play), please refer to their respective money-back
          policies.{" "}
        </span>

        <span className="span">
          In general, subscription fees paid are non-refundable during the
          billing cycle unless required by law.
        </span>

        <span className="text-wrapper">
          {" "}
          Nothing in this Policy shall affect any rights you may have under
          applicable consumer protection laws, which may override the terms
          herein.
          <br />
        </span>
      </p>

      <p className="text">
        <span className="text-wrapper">
          By using our services, you acknowledge that you have read, understood,
          and agreed to this money-back policy.
        </span>
      </p>
    </div>
  );
};
